import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function AiSolutionsPage() {
  return <ServiceDetailLayout slug="ai-solutions" />;
}
